import React from 'react';
import PropTypes from 'prop-types';
import { toast, cssTransition } from 'react-toastify';

const transition = cssTransition({
  enter: 'tvt-notification-flip-enter',
  exit: 'tvt-notification-bounce-exit'
});

const options = {
  className: 'tvt-notification-request-success',
  type: toast.TYPE.SUCCESS,
  autoClose: 3000,
  transition
};

const Component = ({ title, text }) => (
  <div>
    <h1>{title}</h1>
    {text && <p>{text}</p>}
  </div>
);

Component.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string
};

Component.defaultProps = {
  title: 'Success',
  text: null
};

const delay = ms => new Promise(res => setTimeout(res, ms));

export default async ({ toastId, title, text, ...props }) => {
  await delay(1000);
  return toast.update(toastId, {
    ...options,
    render: <Component title={title} text={text} />,
    ...props
  });
};
